<div class="addImanage-doc-popup">
    <form>
        <div class="cmn-modal-header">
            <h4 class="modal-header-title">
                Create document
            </h4>
        </div>
        <div class="cmn-modal-content">
            <div class="form-group form-group-sm">
                <div class="custom-row">
                    <h6 class="cmn-form-label col-3 mb-0 pt-2">
                        Type
                    </h6>
                    <div class="col-9">
                        <div class="form-select-container">
                            <ng-select [items]="documentTypeList" class="cmn-ngselect wthout-ellipsis-option" 
                            bindLabel="documentTypeName" bindValue="documentTypeId" placeholder="Select"
                            [searchable]="false" [clearable]="false" [(ngModel)]="documentType" name="documentTypeSelect"
                            (change)="onDocumentTypeChange()">
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group form-group-sm">
                <div class="custom-row">
                    <h6 class="cmn-form-label col-3 mb-0 pt-2">
                        Template<span class="error-text">*</span>
                    </h6>
                    <div class="col-9">
                        <div class="form-input-container">
                            <input type="text" class="form-control cursor-pointer" placeholder="Select template" [readonly]="true" [value]="templateName" (click)="openTemplateLocationPopup()">
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                    <h6 class="cmn-form-label col-3 mb-0">
                        File name
                    </h6>
                    <div class="col-9">
                        <div class="form-input-container filename-input">
                            <input type="text" class="form-control" placeholder="Enter file name" [(ngModel)]="fileName">
                            <!-- based on file type icon src will be change - take reference from dms create doc component-->
                            <img *ngIf="fileIcon" [src]="fileIcon" class="filenameinput-icon" alt="icon"/>
                        </div>
                    </div>
                </div>
            </div>
        <div *ngIf="documentType === documentTypeId.Merge">
            <div class="form-group form-group-sm">
                <div class="custom-row align-items-center">
                    <h6 class="cmn-form-label col-3 mb-0">
                        Client group
                    </h6>
                    <div class="col-9">
                        <div class="form-select-container">
                            <ng-select [items]="filteredClientGroupList" class="cmn-ngselect" bindLabel="clientGroup"
                                bindValue="clientGroupCode" name="clientGroupSelect" [(ngModel)]="selectedClientGroupCode"
                                (change)="onGroupSelected($event)" [clearable]="true" [virtualScroll]="true" placeholder="Select client group"
                                [selectOnTab]="true" [disabled]="isClientAutoSelectedFromRoute">
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group form-group-sm">
                <div class="custom-row">
                    <h6 class="cmn-form-label col-3 mb-0 pr-0 pt-2">
                        Client name<span class="error-text">*</span>
                    </h6>
                    <div class="col-9">
                        <div class="form-select-container">
                            <ng-select [items]="filteredClientNameList" class="cmn-ngselect" bindLabel="name"
                                bindValue="clientId" name="clientNameSelect" [(ngModel)]="selectedClientId"
                                (change)="onClientSelected($event)" [clearable]="true" [virtualScroll]="true" placeholder="Select client name"
                                [selectOnTab]="true" required [disabled]="isClientAutoSelectedFromRoute">
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group form-group-sm mb-0">
                <div class="custom-row align-items-center">
                    <h6 class="cmn-form-label col-3 mb-0">
                        Client code
                    </h6>
                    <div class="col-9">
                        <div class="form-input-container">
                            <input type="text" class="form-control" placeholder="Enter client code" [readOnly]="true" [value]="selectedClientCode">
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
       
        <div class="cmn-modal-footer">
            <button type="button" mat-button class="cmn-blue-btn mr-2" (click)="addDocument()" [disabled]="isAddDisabled">Create</button>
            <button type="button" mat-button class="cmn-inverse-btn" (click)="closeAddDocPopup()">Cancel</button>
        </div>
    </form>
</div>

<!-- template location popup -->
<ng-template #templateLocationPopup>
  <app-dms-template-location [isNonSharePoint]="isNonSharePoint" (outputParameter)="hideTemplateLocationPopUp()" (templateSelected)="onTemplateSelected($event)"></app-dms-template-location>
</ng-template>
